module.exports = __webpack_public_path__ + "img/new-guide-03-1.ff34b9d1.png";